function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M.208.286l.038-.04A.84.84 0 011.393.208l.04.038L4.5 3.313 7.567.246A.84.84 0 018.714.208l.04.038a.84.84 0 01.038 1.147l-.038.04L5.687 4.5l3.067 3.067a.84.84 0 01.038 1.147l-.038.04a.84.84 0 01-1.147.038l-.04-.038L4.5 5.687 1.433 8.754a.84.84 0 01-1.147.038l-.04-.038a.84.84 0 01-.038-1.147l.038-.04L3.313 4.5.246 1.433A.84.84 0 01.208.286l.038-.04-.038.04z",
  id: "remove-x_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(.5 .5)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "remove-x_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#remove-x_svg__a"
})), React.createElement("use", {
  fill: "#979797",
  fillRule: "nonzero",
  xlinkHref: "#remove-x_svg__a"
}), React.createElement("g", {
  mask: "url(#remove-x_svg__b)",
  fill: "#FFF"
}, React.createElement("path", {
  d: "M-48-10.827H54v30H-48z"
})));

var SvgRemoveX = function SvgRemoveX(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 10
  }, props), _ref, _ref2);
};

export default SvgRemoveX;